import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import { getOpportunityRoutes } from '../../../InvestmentHandler/routes';
import { getOpportunityWizard } from '../../actions';

const WizardStepper = (props) => {
  const {
    user, getOpportunityWizard, data, isLoading, onRoutesChange, onRoutesDisable,
  } = props;
  const { pathname, search } = useLocation();
  const history = useHistory();
  const { accreditationFirst, isAccredited } = user || {};
  const [routes, setRoutes] = useState([]);
  const hasAccreditationRoute = routes.some(({ path }) => path.includes('investor-qualification'));
  const match = matchPath(pathname, { path: '/opportunity/:id/investment' });
  const [completeRoutes, setCompleteRoutes] = useState([]);
  const [allRoutesDisabled, setAllRoutesDisabled] = useState(false);

  useEffect(() => {
    if (isLoading || !Object.keys(data).length) return;

    const updatedRoutes = getOpportunityRoutes(isAccredited, accreditationFirst, data.allowSkipAccreditation);
    if (updatedRoutes.length !== routes.length) setRoutes(updatedRoutes);

    const completedRoutes = {
      ...data.allowSkipAccreditation ? {} : { 'investor-qualification': data.investorQualification },
      agreement: hasAccreditationRoute ? data.investorQualification && data.agreement : data.agreement,
      payment: data.payment,
    };
    const filteredCompleteRoutes = Object.entries(completedRoutes).filter((item) => !!item[1]);

    if (filteredCompleteRoutes.length) {
      const newRoutes = filteredCompleteRoutes.map((route) => `/opportunity/${match.params.id}/investment/${route[0]}`);
      if (completeRoutes.length !== newRoutes.length) {
        setCompleteRoutes(newRoutes);
        onRoutesChange(newRoutes);
      }
      if (completedRoutes.payment && data.counterSigned) {
        setAllRoutesDisabled(true);
        onRoutesDisable(true);
      }
    }
  }, [data, isLoading]);

  useEffect(() => {
    if (!routes.length) return;

    const firstStepPathWithId = routes[0].path.replace(':id', match.params.id);
    if (!completeRoutes.length && pathname !== firstStepPathWithId) {
      history.replace({ pathname: firstStepPathWithId, search });
    }

    const lastRoute = [...completeRoutes].pop();
    if (lastRoute && lastRoute !== pathname) {
      history.replace({ pathname: lastRoute, search });
    }
  }, [completeRoutes, routes]);

  useEffect(() => {
    if (allRoutesDisabled) {
      history.push({
        pathname: [...completeRoutes].pop(),
        search,
      });
    }
    if (completeRoutes.length && pathname === `/opportunity/${match.params.id}/investment`) {
      history.push('/opportunities');
    }
  }, [pathname]);

  useEffect(() => {
    if (!isLoading && !Object.keys(data).length) {
      getOpportunityWizard(match.params.id);
    }
  }, [pathname, match.params.id]);

  return <></>;
};

WizardStepper.defaultProps = {
  user: {},
  data: {},
  isLoading: false,
  getOpportunityWizard: () => undefined,
};

WizardStepper.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  isLoading: PropTypes.bool,
  getOpportunityWizard: PropTypes.func,
  onRoutesChange: PropTypes.func.isRequired,
  onRoutesDisable: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { investment: { opportunityWizard }, auth: { user } } = state;
  return {
    data: opportunityWizard.data,
    isLoading: opportunityWizard.isLoading,
    user: user || {},
  };
};

export default connect(mapStateToProps, { getOpportunityWizard })(WizardStepper);
